import { Redirect, Route, RouteProps, useHistory } from 'react-router-dom';
import { useJurisdiction } from '../hooks';
import { BASE_URL } from '../constants';
import { useAuth } from '../contexts/auth.context';

type ProtectedRouteProps = RouteProps;

const ProtectedRoute = (props: ProtectedRouteProps) => {
    const { location } = useHistory();

    const {
        slug,
        isRequestPasswordProtected,
        isRequestEmailVerification,
        isRequestPhoneVerification
    } = useJurisdiction();
    
    const { isPasswordVerified, isEmailVerified, isPhoneVerified } = useAuth();

    if (isRequestPasswordProtected && !isPasswordVerified) {
        return (
            <Redirect
                to={{
                    pathname: `${BASE_URL}/${slug}/login`,
                    search: `?backTo=${encodeURIComponent(`${location.pathname}${location.search ?? ''}`)}`,
                }}
            />
        );
    }

    if (isRequestEmailVerification && !isEmailVerified) {
        return (
            <Redirect
                to={{
                    pathname: `${BASE_URL}/${slug}/email-verification`,
                    search: `?backTo=${encodeURIComponent(`${location.pathname}${location.search ?? ''}`)}`,
                }}
            />
        );
    }

    if (isRequestPhoneVerification && !isPhoneVerified) {
        return (
            <Redirect
                to={{
                    pathname: `${BASE_URL}/${slug}/phone-verification`,
                    search: `?backTo=${encodeURIComponent(`${location.pathname}${location.search ?? ''}`)}`,
                }}
            />
        );
    }

    return (
        <Route {...props} />
    );
};

export { ProtectedRoute };
